import { ButtonStyled } from './Buttons.styled';
import { TextStyled } from './Text.styled';

import { css, CSSObject } from '@emotion/react';
import styled from '@emotion/styled';
import { mq } from '@hangar31/rc-layout';
import toColor from '@OnArk/utils/toColor';

export const GoBoxStyled = styled.div(
  ({ theme }) =>
    mq({
      h1: [
        theme.font('xs', 'md'),
        undefined,
        undefined,
        theme.font('sm', 'md'),
      ],
      p: [theme.font('xs'), undefined, undefined, theme.font('sm')],
    }),
  ({ theme }) => css`
    position: relative;

    background: ${theme.colors.whiteDark};

    border: 1px solid ${theme.colors.border};
    border-radius: ${theme.radius.md};

    &:before {
      position: absolute;
      top: -0.1rem;
      bottom: -0.1rem;
      left: -0.1rem;

      background-color: ${toColor(theme.church.bannerColor)};
      border-radius: ${theme.radius.md} 0 0 ${theme.radius.md};
      content: '';
    }

    h1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0;

      line-height: 1em;
      text-transform: uppercase;
      span {
        margin-right: 1rem;
      }
      ${ButtonStyled} {
        min-width: 8rem;
        margin: 1.5rem 0 1.5rem auto;

        box-shadow: none;
      }
    }
    > ${TextStyled} {
      min-height: 0 !important;
      margin: 0;
      padding: 1.6rem 1.6rem 1.6rem 3rem !important;

      line-height: 1.14;

      background-color: ${theme.colors.white};
      border-top: 1px solid ${theme.colors.border};
      border-radius: 0 0 ${theme.radius.md} ${theme.radius.md};
    }

    a {
      transition: all 0.2s;
      + i {
        margin-right: 0.8rem;

        transition: all 0.2s;
      }
      &:hover {
        + i {
          margin-right: -0rem;
          margin-left: 0.8rem;
        }
      }
    }
  `,
  mq({
    ':before': { width: ['1rem', undefined, undefined, '1.5rem'] },
    a: {
      ' + i': { display: ['none', undefined, undefined, 'inline-block'] },
      fontSize: ['1.2rem', undefined, undefined, '1.4rem'],
      margin: [
        '1rem 0 1rem auto',
        undefined,
        undefined,
        '1.5rem 0 1.5rem auto',
      ],
      padding: ['0.5rem 2rem', undefined, undefined, '0.9rem 2.7rem'],
    },
    h1: { marginLeft: ['2rem', undefined, undefined, '3rem'] },
  })
);

export const ExpandableStyled = styled.article<{ open?: boolean }>(
  () => css`
    overflow: hidden;

    p {
      padding: 1rem;
      overflow: hidden;

      transition: all 0.2s;
    }
  `,
  ({ open }): CSSObject => ({
    i: { transform: `rotate(${open ? '-180deg' : '0deg'})` },
    p: {
      maxHeight: open ? '10rem' : '0',
      paddingBottom: open ? 'inherit' : '0',
      paddingTop: open ? 'inherit' : '0',
    },
  })
);
